import axios from "axios";

export async function uploadCvToServer(
  file,
  { endpoint = "https://cv-server-upload.saaeda.com/api/upload-cv" } = {}
) {
  const fd = new FormData();
  fd.append("file", file);

  console.log("📤 Uploading file:", {
    name: file.name,
    type: file.type,
    size: `${(file.size / 1024).toFixed(2)} KB`,
    endpoint,
  });

  try {
    const res = await axios.post(endpoint, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 20000,
    });

    console.log("✅ Upload Response:", res);

    // Validate that the response includes a proper file path
    if (!res.data?.url || !res.data.url.includes("/storage/cv/")) {
      throw new Error(
        `Unexpected response: URL missing file path. Got: ${res.data.url}`
      );
    }

    return res.data;
  } catch (error) {
    console.error("❌ Upload error details:", error);

    if (error.response) {
      console.error("📩 Server responded with:", error.response.data);
      throw new Error(
        error.response.data?.message ||
          error.response.data?.error ||
          `Server error: ${error.response.status}`
      );
    } else if (error.request) {
      console.error("🚫 No response received from server.", error.request);
      throw new Error(
        "No response from server. Please check your connection or server status."
      );
    } else {
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
}
